import { client } from './setup';
import { AUTH_API } from '../globals';

export default {
    login: (user) => client.post(`${AUTH_API}/login`, user),
}